import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { RequestDetails } from './components/request-details/request-details';
import { DiffView } from './components/diff-view/diff-view';
import { Settings } from './components/admin/settings/settings';
import { SkillsManager } from './components/admin/skills/skills-manager';
import { AiSettings } from './components/admin/ai-settings/ai-settings';
import { GithubSettings } from './components/admin/github-settings/github-settings';
import { PersonalTokens } from './components/admin/personal-tokens/personal-tokens';
import { Reports } from './components/admin/reports/reports';
import { Forbidden } from './components/forbidden/forbidden';
import { canActivateAuthenticated } from './guards/keycloak.guard';
import { authGuard } from './guards/auth.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    path: '',
    component: Home,
    canActivate: [authGuard],
  },
  {
    path: 'search',
    component: RequestDetails,
    canActivate: [canActivateAuthenticated, authGuard],
  },
  {
    path: 'diff',
    component: DiffView,
    canActivate: [canActivateAuthenticated, authGuard],
  },
  {
    path: 'admin/settings',
    component: Settings,
    canActivate: [canActivateAuthenticated, authGuard],
    children: [
      { path: '', redirectTo: 'ai', pathMatch: 'full' },
      { path: 'ai', component: AiSettings, canDeactivate: [unsavedChangesGuard] },
      { path: 'templates', component: SkillsManager, canDeactivate: [unsavedChangesGuard] },
      { path: 'github', component: GithubSettings },
      { path: 'tokens', component: PersonalTokens },
    ],
  },
  {
    path: 'admin/reports',
    component: Reports,
    canActivate: [canActivateAuthenticated, authGuard],
  },
  // Back-compat: the old standalone routes now live as Settings tabs.
  { path: 'admin/skills', redirectTo: 'admin/settings/templates' },
  { path: 'admin/ai-settings', redirectTo: 'admin/settings/ai' },
  // Registered so guards can deny visibly. A guard returning
  // parseUrl('/forbidden') with nothing at that path falls through to the
  // wildcard below and lands the user back on home with no explanation,
  // which is indistinguishable from a broken link. Deliberately
  // unguarded: gating this page could only ever loop.
  { path: 'forbidden', component: Forbidden },
  { path: '**', redirectTo: '' },
];
